let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("30B0p")).then(() => parcelRequire('cyKX8'));